module.exports = __webpack_public_path__ + "img/correos.eda4a132.png";